import type { UserState } from '../../types';
import {
  FETCH_USER_INFO,
  REDUCE_UNREAD_ALL_MESSAGE_CONTEXT_COUNT,
  REDUCE_UNREAD_COUNT,
  TOGGLE_DESIRED_CONDITIONS_ANSWER,
  TOGGLE_PERSONALITY_ANSWER,
  UPDATE_UNREAD_ALL_MESSAGE_CONTEXT_COUNT,
  UPDATE_UNREAD_COUNT,
  UPDATE_USER_CAREER_MOTIVATION,
} from '../actions/action-types';

// TODO: 引数の state に対する assignment operator や Object.assign による副作用が多数あるのでやめる。
//       それらの副作用によって更新された state は shallow equal となり得て、その結果
//       React の render をトリガーしない可能性がある。

export function user(
  state: UserState = {
    accounts: {
      github: {},
      twitter: {},
      qiita: {},
    },
    external_services: {
      connpass: '',
      zenn: '',
      note: '',
      blog: '',
      speaker_deck: '',
      slide_share: '',
    },
    block_company_input: '', // TODO: フォームの値っぽい？ 不要そうなら削除
    block_company_input_autocomplete_list: [],
    block_companies: [],
    block_skills: [],
    company_name: '',
    deleted_reasons: [],
    desired_locations: [],
    github_activities_v2: {
      // contribution_rank_in_this_month: '-',
      contributions_in_total: '',
      contributions_in_this_year: '',
      contributions_in_this_month: '',
      pull_requests_in_total: '',
      pull_requests_in_this_year: '',
      pull_requests_in_this_month: '',
      stars_in_total: '',
      stars_in_this_year: '',
      stars_in_this_month: '',
    },
    job_year_types: [],
    job_selected_count: 0,
    jobs: [],
    management_job_year_types: [],
    management_jobs: [],
    management_job_selected_count: 0,
    predicted_salaries: {
      lower: 0,
      upper: 0,
      management_experience: false,
    },
    influence_score_analysis: {},
    prefectures: [],
    personality_questions: [],
    selectable_skills: [],
    resume: {},
    work_histories: [],
    team_scale_types: [],
    position_types: [],
    github_summary: {
      summary: {},
      activities: [],
    },
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any
): UserState {
  // エラーハンドリングは App reducer が共通的に行うため、その他の reducer ではエラー時は何もしない。
  if (action.error) {
    return state;
  }

  switch (action.type) {
    case FETCH_USER_INFO: {
      return action.error
        ? state
        : {
            ...state,
            ...action.payload,
          };
    }
    case TOGGLE_PERSONALITY_ANSWER: {
      const newPersonalityQuestions: typeof state.personality_questions = [];
      const { answer_id, personality_question_id } = action;
      const statePersonalityQuestions = state.personality_questions ?? [];
      const targetPersonalityQuestion = state.personality_questions
        ?.filter((item) => personality_question_id === item.id)
        .pop();
      const isSelected =
        targetPersonalityQuestion?.user_answers.indexOf(answer_id) !== -1;

      if (isSelected) {
        statePersonalityQuestions.forEach((question) => {
          // 削除

          if (question.id === personality_question_id) {
            question.user_answers = question.user_answers.filter(
              (id) => answer_id !== id
            );
          }
          newPersonalityQuestions.push(question);
        });
      } else {
        statePersonalityQuestions.forEach((question) => {
          // 追加
          if (question.id === personality_question_id) {
            question.user_answers.push(answer_id);
          }
          newPersonalityQuestions.push(question);
        });
      }

      return Object.assign({}, state, {
        personality_questions: newPersonalityQuestions,
      });
    }
    case TOGGLE_DESIRED_CONDITIONS_ANSWER: {
      const newDesiredConditions: typeof state.desired_conditions = [];
      const { answer_id, question_id } = action;
      const stateDesiredConditions = state.desired_conditions ?? [];
      const targetDesiredConditions = state.desired_conditions
        ?.filter((item) => question_id === item.id)
        .pop();
      const isSelected =
        (targetDesiredConditions?.user_answers ?? []).indexOf(
          action.answer_id
        ) !== -1;

      if (isSelected) {
        stateDesiredConditions.forEach((question) => {
          // 削除

          if (question.id === question_id) {
            question.user_answers = question.user_answers.filter(
              (id) => answer_id !== id
            );
          }
          newDesiredConditions.push(question);
        });
      } else {
        stateDesiredConditions.forEach((question) => {
          // 追加
          if (question.id === question_id) {
            question.user_answers.push(answer_id);
          }
          newDesiredConditions.push(question);
        });
      }

      return Object.assign({}, state, {
        desired_conditions: newDesiredConditions,
      });
    }
    case UPDATE_USER_CAREER_MOTIVATION: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case REDUCE_UNREAD_COUNT: {
      const { amount } = action.payload;

      if (typeof state.unread_count !== 'number') {
        throw Error();
      }

      return {
        ...state,
        unread_count: state.unread_count - amount,
      };
    }
    case UPDATE_UNREAD_COUNT: {
      const { unreadCount } = action.payload;

      return {
        ...state,
        unread_count: unreadCount,
      };
    }
    case REDUCE_UNREAD_ALL_MESSAGE_CONTEXT_COUNT: {
      const { amount } = action.payload;

      if (typeof state.unread_all_message_context_count !== 'number') {
        throw Error();
      }

      return {
        ...state,
        unread_all_message_context_count:
          state.unread_all_message_context_count - amount,
      };
    }
    case UPDATE_UNREAD_ALL_MESSAGE_CONTEXT_COUNT: {
      const { unreadAllMessageContextCount } = action.payload;

      return {
        ...state,
        unread_all_message_context_count: unreadAllMessageContextCount,
      };
    }
    default:
      return state;
  }
}
